var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProductionHistoryChart',{attrs:{"chart-data":_vm.chartData,"unit":_vm.production ? _vm.production.unit : '',"hide-labels":_vm.hideLabelsAggregated,"show-legend":_vm.showLegend},on:{"labels-width":function($event){return _vm.$emit('labels-width', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }